import { dashboardDevelopersTabs } from '@developer/portal/config';

function findDeveloperDashboardTabByWindowPathname() {
  return Object.values(dashboardDevelopersTabs).find(
    (el) =>
      el.link === window.location.pathname ||
      window.location.pathname.includes(el.link)
  );
}

export function findDeveloperDashboardTabIdByWindowPathname() {
  return findDeveloperDashboardTabByWindowPathname()?.id;
}
